import {Scope} from "@/types/Scope";
import {Vulnerability} from "@/types/Vulnerability";
import {getRequest} from "@/lib/api_client";

interface FetchReportFormProps {
  form_id: string;
}

interface ReportFormProps {
  workspace_name: string;
  logo_url: string;
  allow_scope: boolean;
  scopes: Scope[] | null;
  allow_severity: boolean;
  severities: string[];
  allow_vulnerability: boolean;
  vulnerabilities: Vulnerability[] | null;
  allow_cve: boolean;
  allow_attachments: boolean;
}

export class ReportForm implements ReportFormProps {
  workspace_name: string;
  logo_url: string;
  allow_scope: boolean;
  scopes: Scope[] | null;
  allow_severity: boolean;
  severities: string[];
  allow_vulnerability: boolean;
  vulnerabilities: Vulnerability[] | null;
  allow_cve: boolean;
  allow_attachments: boolean;

  constructor(data: ReportFormProps) {
    this.workspace_name = data.workspace_name;
    this.logo_url = data.logo_url;
    this.allow_scope = data.allow_scope;
    this.allow_severity = data.allow_severity;
    this.severities = data.severities;
    this.allow_vulnerability = data.allow_vulnerability;
    this.allow_cve = data.allow_cve;
    this.allow_attachments = data.allow_attachments;

    if (!data.scopes) {
      this.scopes = null;
    } else {
      this.scopes = data.scopes.map((scope) => new Scope(scope));
    }

    if (!data.vulnerabilities) {
      this.vulnerabilities = null;
    } else {
      this.vulnerabilities = data.vulnerabilities.map((vulnerability) => new Vulnerability(vulnerability));
    }
  }

  static async fetchReportForm({form_id}: FetchReportFormProps): Promise<ReportForm> {
    return getRequest<ReportFormProps>(`/forms/${form_id}`).then((data) => new ReportForm(data));
  }
}
